
import Installer from './installer'
import * as tu from './terminal-utils'
import { Spinner } from 'cli-spinner'
import path from 'path'
import colors from 'chalk'
import fs from 'fs-extra'
import { FURTHER_PATH } from './utils'
import os from 'os'
const spinner = new Spinner('%s Starting up...')
spinner.setSpinnerString('⠉⠑⠡⢁⡁⡈⠌⠊') // '◷◶◵◴'

const DEPS = require('./technologies/deps.js')
let lastCursorPosition = { row: 0, col: 0}
let numCPUs = os.cpus().length
numCPUs = Math.ceil(numCPUs / 2)
// numCPUs = numCPUs > 1 ? numCPUs - 1 : numCPUs

export async function ensureInstallation (depGroup, deps = null, opts = {}) {

    let depsList = []

    if (deps) {
        deps = Array.isArray(deps) ? deps : [deps]
    }

    if (opts.installing && opts.installing.threads) {
        numCPUs = opts.installing.threads
    }

    if (opts.installing && opts.installing.threads) {
        numCPUs = opts.installing.threads
    }
    
    if (DEPS[depGroup]) {
        for(let dep in DEPS[depGroup]) {
            if (deps) {
                deps = Array.isArray(deps) ? deps : [deps]
                // install only the given dependencies
                if (deps.indexOf(dep) >= 0) {
                    depsList.push(`${dep}@${DEPS[depGroup][dep] || '*'}`)
                }
            } else {
                // install the whole group
                depsList.push(`${dep}@${DEPS[depGroup][dep] || '*'}`)
            }
        }
    }

    return await new Promise(async (resolve, reject) => {

        let installData = {
            dependencies: depsList
        }
        
        const resolver = function (result) {
            global.isInstalling = false
            resolve(result)
        }

        const defaultNModules = FURTHER_PATH
        opts.node_modules = opts.node_modules || defaultNModules

        if (opts.verbose) {
            installData.stdio = 'inherit'
        }
        if (opts.node_modules) {
            installData.cwd = opts.node_modules // + '../'
        }

        // getting the list of all currently installed modules
        let pkgJson = {}
        let deps = new Set()
        
        try {
            pkgJson = fs.readFileSync(path.resolve(installData.cwd, 'package.json'), 'utf8')
            pkgJson = JSON.parse(pkgJson)
            deps = new Set(Object.keys(pkgJson.dependencies).concat(Object.keys(pkgJson.devDependencies)))
        } catch(e) {}

        let hasToInstall = false
        let listToInstall = []
        let installableCounter = 0
        let tmpChunk = []

        for(let i = 0, l = depsList.length; i < l; i++) {
            let dep = depsList[i].split('@')
            if (!deps.has(dep[0])) {
                // if there is at least one dependency missing, we try and install it
                hasToInstall = true
                installableCounter++
                if (dep[1]) {
                    // we will install a given version (or in a range)
                    tmpChunk.push(depsList[i])
                } else {
                    // no version was specified
                    tmpChunk.push(dep[0])
                }
                // we will use half the cores from the CPUs to
                // paralelize the installations
                if (tmpChunk.length >= numCPUs) {
                    listToInstall.push(tmpChunk)
                    tmpChunk = []
                }
            }
        }
        if (tmpChunk.length) {
            listToInstall.push(tmpChunk)
        }

        // this will update the general status bar (for all the modules supposed
        // to install for the current enabled technology) (the statusbar)
        let installed = 0
        let lineSize = tu.getLineSize()
        function updateInstalationBar () {
            let percInstalled = installed * 100 / (installableCounter)
            percInstalled = lineSize * percInstalled / 100
            let statusStr = colors.bgBlueBright(''.padEnd(percInstalled, ' ')) +
                ''.padEnd(lineSize - percInstalled, '-')
            tu.moveTo('position', {
                row: lastCursorPosition.row - 1,
                col: lastCursorPosition.col
            })
            process.stdout.write(colors.blueBright(statusStr))
        }

        if (!hasToInstall) {
            resolver()
        } else {

            tu.clearTerminal()
            console.log(// '\n\n' +
                colors.bold.blue('[i] ') +
                `> To enable ` +
                colors.bold(depGroup + ' technologies, ') +
                `we need to install some extra dependencies.\n`+
                `Please wait while we install them for you.` +
                '\n'
            )

            global.isInstalling = true
            lastCursorPosition = tu.getCursorPosition()
            updateInstalationBar()

            for (let i = 0, l = listToInstall.length; i < l; i++) {
                await installGroup(
                    listToInstall[i],
                    installData,
                    _ => {
                        installed++
                        updateInstalationBar()
                    }
                )
            }
            resolver(true)
        }
    })
}

// install groups of chunks of dependencies
async function installGroup (group, installData, cb) {
    const instalationPath = installData.cwd

    return Promise.all(group.map((dep, i) => {
        return new Installer({
            cwd: instalationPath,
            dep,
            concurrently: numCPUs,
            startingRow: lastCursorPosition.row,
            pos: {
                row: lastCursorPosition.row + (i * 2),
                col: lastCursorPosition.col
            }
        }, cb)
    })).then(results => {
        let pkgDeps = {}
        let pkgLockDeps = {}

        results.forEach(instld => {
            // installed.installData.dependencies has the list of
            // the sub-dependencies that were also installed
            // lets store all the sub-dependencies into an object
            pkgLockDeps = Object.assign(
                {},
                pkgLockDeps,
                instld.installData.dependencies
            )
            // and store the current dependency into another object
            pkgDeps[instld.name] = instld.version
        })

        // update the further's package-lock and package with
        // the installed dependencies
        // this needs to be sync to avoid any locked file error.
        // Firstly, we resolve their paths and read the current json
        const pkgJsonPath = path.resolve(instalationPath, 'package.json')
        const pkgLockJsonPath = path.resolve(instalationPath, 'package-lock.json')

        // update the further's package-lock with the depnames
        try {
            let pkgLockJson = fs.readJsonSync(pkgLockJsonPath)
            pkgLockJson.dependencies = Object.assign({},
                pkgLockJson.dependencies,
                pkgLockDeps
            )
            fs.writeJsonSync(pkgLockJsonPath, pkgJson, { spaces: 2 })
        } catch (err) {
            // probably there wasn't a package-lock.json
        }

        // update the further's package with the depnames
        let pkgJson = fs.readJsonSync(pkgJsonPath)
        pkgJson.dependencies = Object.assign({},
            pkgJson.dependencies,
            pkgDeps
        )
        fs.writeJsonSync(pkgJsonPath, pkgJson, { spaces: 2 })

        // when a group is done, we clean all of its lines
        for (let i = lastCursorPosition.row - 1, l = lastCursorPosition.row + numCPUs * 2 + 2; i < l; i++) {
            tu.moveTo('position', {
                row: i,
                col: 0
            })
            tu.clearLine()
        }
        tu.moveTo('position', {
            row: lastCursorPosition.row + 1,
            col: lastCursorPosition.col
        })
    })
}

// retrieves the list of dependencies (all of them
// or the dependencies within a group) from ./deps.js
export function getDepsList (group) {
    if (group) {
        return Object.keys(DEPS[group] || {})
    } else {
        let finalList = []
        Object.keys(DEPS || {}).forEach(group => {
            finalList = finalList.concat(Object.keys(group || {}))
        })
        return finalList
    }
}



// WEBPACK FOOTER //
// ./src/npm-dyn-dependencies.js